/* BoxyLoot — minimal theme JS */
(function () {
  'use strict';

  function initHeroAutoplayMedia(scope) {
    const root = scope || document;
    root.querySelectorAll('[data-hero-autoplay]').forEach((media) => {
      if (media.dataset.heroAutoplayBound === 'true') return;
      media.dataset.heroAutoplayBound = 'true';

      const delay = Number.parseInt(media.dataset.delay || '2000', 10);
      const wait = Number.isFinite(delay) ? Math.max(0, delay) : 2000;
      const video = media.querySelector('video.hero-media__video');
      const gif = media.querySelector('[data-hero-gif]');
      if (!video && !gif) return;

      window.setTimeout(() => {
        const revealMotion = () => {
          media.classList.add('is-motion-ready');
        };

        if (gif instanceof HTMLImageElement && gif.dataset.src) {
          gif.addEventListener('load', revealMotion, { once: true });
          gif.src = gif.dataset.src;
          if (gif.complete && gif.naturalWidth > 0) revealMotion();
          return;
        }

        if (video instanceof HTMLVideoElement) {
          video.muted = true;
          video.loop = true;
          video.playsInline = true;
          const play = video.play();
          if (play && typeof play.catch === 'function') {
            play.then(revealMotion).catch(() => {
              media.classList.remove('is-motion-ready');
            });
          } else {
            revealMotion();
          }
        }
      }, wait);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initHeroAutoplayMedia(document));
  } else {
    initHeroAutoplayMedia(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initHeroAutoplayMedia(event.target);
  });

  function initHoverMedia(scope) {
    const root = scope || document;
    root.querySelectorAll('[data-hover-media]').forEach((media) => {
      if (media.dataset.hoverMediaBound === 'true') return;
      media.dataset.hoverMediaBound = 'true';

      const card = media.closest('a, button, [tabindex]');
      const video = media.querySelector('video.drop-card__hover-video');
      const image = media.querySelector('[data-hover-image]');
      const target = card || media;

      const loadImage = () => {
        if (image instanceof HTMLImageElement && image.dataset.src && image.src !== image.dataset.src) {
          image.src = image.dataset.src;
        }
      };

      const play = () => {
        loadImage();
        if (!(video instanceof HTMLVideoElement)) return;
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        const promise = video.play();
        if (promise && typeof promise.catch === 'function') promise.catch(() => {});
      };

      const stop = () => {
        if (!(video instanceof HTMLVideoElement)) return;
        video.pause();
        try {
          video.currentTime = 0;
        } catch (err) {}
      };

      target.addEventListener('pointerenter', play);
      target.addEventListener('focusin', play);
      target.addEventListener('pointerleave', stop);
      target.addEventListener('focusout', stop);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initHoverMedia(document));
  } else {
    initHoverMedia(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initHoverMedia(event.target);
  });

  function selectContactTopic(topicKey) {
    if (!topicKey) return null;
    const select = document.querySelector('[data-contact-topic-select]');
    if (!(select instanceof HTMLSelectElement)) return null;

    const option = Array.from(select.options).find((item) => (
      item.dataset.topicKey === topicKey || item.value === topicKey
    ));
    if (!option) return null;

    select.value = option.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
    return select;
  }

  function initContactTopicLinks(scope) {
    const root = scope || document;
    const requestedTopic = new URLSearchParams(window.location.search).get('contact_topic');
    selectContactTopic(requestedTopic);

    root.querySelectorAll('[data-contact-topic]').forEach((trigger) => {
      if (trigger.dataset.contactTopicBound === 'true') return;
      trigger.dataset.contactTopicBound = 'true';

      trigger.addEventListener('click', (event) => {
        if (!(trigger instanceof HTMLAnchorElement)) return;

        const targetUrl = new URL(trigger.href, window.location.href);
        const normalizePath = (path) => path.replace(/\/+$/, '') || '/';
        const isCurrentPage = (
          targetUrl.origin === window.location.origin &&
          normalizePath(targetUrl.pathname) === normalizePath(window.location.pathname)
        );
        if (!isCurrentPage || !targetUrl.hash) return;

        const target = document.getElementById(targetUrl.hash.slice(1));
        if (!target) return;

        event.preventDefault();
        const topicKey = trigger.dataset.contactTopic || targetUrl.searchParams.get('contact_topic');
        const select = selectContactTopic(topicKey);
        window.history.replaceState({}, '', `${targetUrl.pathname}${targetUrl.search}${targetUrl.hash}`);
        target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });

        if (select) {
          window.setTimeout(() => select.focus({ preventScroll: true }), 450);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initContactTopicLinks(document));
  } else {
    initContactTopicLinks(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initContactTopicLinks(event.target);
  });

  function initDesignerPartners(scope) {
    const root = scope || document;
    const sections = [];

    if (root instanceof Element && root.matches('[data-designer-partners]')) {
      sections.push(root);
    }
    root.querySelectorAll('[data-designer-partners]').forEach((section) => sections.push(section));

    sections.forEach((section) => {
      if (section.dataset.designerPartnersBound === 'true') return;

      const button = section.querySelector('[data-designer-toggle]');
      const extras = section.querySelectorAll('[data-designer-extra]');
      if (!(button instanceof HTMLButtonElement) || extras.length === 0) return;

      section.dataset.designerPartnersBound = 'true';
      section.classList.add('dpartner--collapsible');
      button.hidden = false;

      button.addEventListener('click', () => {
        const expanded = !section.classList.contains('dpartner--expanded');
        section.classList.toggle('dpartner--expanded', expanded);
        button.setAttribute('aria-expanded', String(expanded));

        const label = button.querySelector('[data-designer-toggle-label]');
        if (label) {
          label.textContent = expanded ? button.dataset.collapseLabel : button.dataset.expandLabel;
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initDesignerPartners(document));
  } else {
    initDesignerPartners(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initDesignerPartners(event.target);
  });

  // FAQ details polyfill (close others when one opens, optional)
  document.addEventListener('click', (e) => {
    const target = e.target;
    if (!(target instanceof HTMLElement)) return;
    const summary = target.closest('summary[data-faq]');
    if (!summary) return;
    const details = summary.parentElement;
    if (!details) return;
    document.querySelectorAll('details[data-faq-group]').forEach((d) => {
      if (d !== details) d.removeAttribute('open');
    });
  });

  // Cart count refresh after add-to-cart form submission
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    const btn = form.querySelector('button[type=submit]');
    const original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
        body: new URLSearchParams(new FormData(form)),
      });
      if (!res.ok) throw new Error('add failed');
      const cart = await fetch('/cart.js').then((r) => r.json());
      const counts = document.querySelectorAll('[data-cart-count]');
      counts.forEach((el) => { el.textContent = String(cart.item_count); });
      if (btn) btn.textContent = 'Added ✓';
      setTimeout(() => { if (btn) { btn.textContent = original; btn.disabled = false; } }, 1400);
    } catch (err) {
      if (btn) { btn.textContent = original || 'Add to bag'; btn.disabled = false; }
      console.error(err);
    }
  });

  // Header hide-on-scroll-down (subtle)
  let lastY = 0;
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      if (y > lastY && y > 200) header.classList.add('site-header--hidden');
      else header.classList.remove('site-header--hidden');
      lastY = y;
    }, { passive: true });
  }
})();
